export const criteoApiUrl = 'https://d.us.criteo.com/delivery/retailmedia';
export const partnerId = '11251';

export const deviceMapping = {
    d: 'desktop',
    m: 'mobile',
    aa: 'android',
    aios: 'iOS',
};

export const pageTypeMapping = (payload) => {
    const mapping = {
        Home: {
            eventType: 'viewHome',
            params: {},
        },
        Gallery: {
            eventType: 'viewCategory',
            params: {
                category: payload?.params?.id,
                'page-number': payload?.params?.page ? payload.params.page : 1,
            },
        },
        Search: {
            eventType: 'viewSearchResult',
            params: {
                keywords: payload?.params?.searchTerm,
                'page-number': payload?.params?.page ? payload.params.page : 1,
            },
        },
        PDP: {
            eventType: 'viewItem',
            params: {
                'parent-item': payload?.parentItem,
                price: payload?.price,
                availability: payload?.availability,
                ...(payload?.item && { item: payload.item }),
            },
        },
        OrderConfirmation: {
            eventType: 'trackTransaction',
            params: {
                'transaction-id': payload?.transaction,
                item: payload?.item,
                price: payload?.price,
                quantity: payload?.quantity,
            },
        },
    };

    return mapping[payload?.pageType] || null;
};
